module.exports = __webpack_public_path__ + "static/media/Illus-Dressing_3.9fcb695a.png";